import Cookies from "js-cookie";

export interface ICookiesOptions {
  days?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
}

export type ParamValue = string | number | boolean;
export type CookieItem = Record<string, unknown> | ParamValue;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getCookie(key: string): string | null | any {
  const cookie = Cookies.get(key);

  if (!cookie) {
    return null;
  }

  try {
    return JSON.parse(cookie);
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return cookie;
  }
}

export const setCookie = (key: string, value: CookieItem, options: ICookiesOptions = {}): void => {
  const { days, path, domain, secure } = options;
  const expires = days ? Date.now() + days * 24 * 60 * 60 * 1000 : undefined;

  const stringifiedValue = typeof value === "object" ? JSON.stringify(value) : String(value);

  Cookies.set(key, stringifiedValue, { expires, path, domain, secure });
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const removeCookie = (key: string, options: ICookiesOptions = {}) => Cookies.remove(key, options);
